module.exports = "/_next/static/images/00529f43d36b6abd4a9f0aeb0e42d8cf-cards.png";